package com.example.ramsembedded.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.example.ramsembedded.components.layouts.PageLayout
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.alignItems
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.fontWeight
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Page
@Composable
fun AboutUsPage() {
    PageLayout("About Us"){
       AboutUsPageContent()
    }

}

@Composable
fun AboutUsPageContent() {
    Div(
        attrs = {
            style {
                padding(20.px)
                fontFamily("Arial", "sans-serif")
            }
        }
    ) {
        Section(attrs = {
        }) {

            // About Us List
            Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(
                AlignItems.Center) } }) {

                MissionVisionItem("Our Journey","At Rams Embedded, our journey began in 2012, and we officially established ourselves as RAM’S EMBEDDED IT SOLUTIONS PRIVATE LIMITED in 2017. Since then, we've been at the forefront of embedded systems development, specializing in Automotive Software Technologies. We are proud to be pioneers in this field, pushing the boundaries of innovation.",
                    icon = "🛣️",
                    titleColor = Color("#D4AF37") )

                MissionVisionItem("Our Mission","Our dedicated team is passionate about equipping both enthusiasts and professionals with the latest insights and resources in the ever-evolving tech world. We aim to empower you to navigate the complexities of modern technology and excel in your career."
                ,icon = "🎯",
                    titleColor = Color("#2A5C82"))

                MissionVisionItem("Our Vision","We envision leading the development of indigenous products and technologies, working closely with academic institutions to drive groundbreaking solutions that will shape India’s industrial landscape."
                ,icon = "🔭",
                    titleColor = Color("#1A7F64"))

                MissionVisionItem("Expertise and Recognition","To date, we’ve trained over 1,200 students, providing them with the skills and knowledge needed to succeed. We are proud to have placed our graduates in leading IT companies across India, helping them kickstart successful careers."
                ,icon = "🏆",
                    titleColor = Color("#8A4EBF"))
            }
        }
    }
}



@Composable
fun MissionVisionItem(
    title: String,
    content: String,
    icon: String = "✔️",
    titleColor: CSSColorValue = Color("#2A5C82")
) {
    val isHovered = remember { mutableStateOf(false) }

    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.FlexStart)
            padding(2.cssRem)
            borderRadius(12.px)
            backgroundColor(if (isHovered.value) Color("#F8FAFF") else Color("white"))
            boxShadow(if (isHovered.value) "0 4px 12px rgba(0, 0, 0, 0.1)" else "0 2px 6px rgba(0, 0, 0, 0.08)")
            marginBottom(2.cssRem)
            property("transition", "all 0.3s ease")
            width(100.percent)
        }
        onMouseEnter { isHovered.value = true }
        onMouseLeave { isHovered.value = false }
    }) {
        // Icon Container
        Div(attrs = {
            style {
                flexShrink(0)
                marginRight(1.5.cssRem)
                padding(0.8.cssRem)
                borderRadius(50.percent)
            }
        }) {
            Span(attrs = {
                style {
                    fontSize(2.cssRem)
                    color(titleColor)
                    display(DisplayStyle.Block)
                }
            }) { Text(icon) }
        }

        // Content Container
        Div(attrs = {
            style {
                flexGrow(1)
            }
        }) {
            H3(attrs = {
                style {
                    fontSize(1.6.cssRem)
                    color(titleColor)
                    fontWeight(FontWeight.SemiBold)
                    marginBottom(0.8.cssRem)
                    property("line-height", "1.4")
                }
            }) { Text(title) }

            P(attrs = {
                style {
                    fontSize(1.1.cssRem)
                    color(Color("#444"))
                    property("line-height", "1.6")
                    com.varabyte.kobweb.compose.css.margin(0.cssRem)
                }
            }) { Text(content) }
        }
    }
}
